import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import MainPage from './pages/MainPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<MainPage />} />
      </Routes>
      <Toaster position="top-right" toastOptions={{
        style: { fontFamily: 'DM Sans, sans-serif', borderRadius: '12px', fontSize: '14px',
                 background: '#141028', color: '#fff', border: '1px solid rgba(61,31,204,0.25)' },
        success: { iconTheme: { primary: '#3D1FCC', secondary: '#fff' } }
      }} />
    </BrowserRouter>
  );
}
